import { LoggerStrategies } from 'src/app/constants/logger';

const loggerStrategy = LoggerStrategies.GOOGLE;

const keycloak = {
  url: 'https://ltdev.tipmexico.com/auth',
  realm: 'master',
  clientId: 'client_tip_dev',
  redirectUri: 'https://ltdev.tipmexico.com/v2',
  bearerExcludedUrls: [
    'https://cmsltdev.tipmexico.com',
    'https://api-ssl.bitly.com/v4/shorten',
  ],
};

const sse = {
  url: `https://ltdev.tipmexico.com/v1/service/sse`,
  retryInterval: 5000,
  maxRetries: 10,
};

const gtm = {
  googleTagManagerId: 'x',
};

const incode = {
  host: 'https://demo-onboarding.incodesmile.com/',
  account: 'engencapital887',
  flowDigital: '66bd45c96b6cd4f999f456d5',
  flowCredit: '66bd45f16b6cd4f999f45996',
  region: 'region=ALL',
  production: false
}

const miFiel = {
  base: `https://app-sandbox.mifiel.com/sign-widget-v1.0.0.js`,
};

const bitly = {
  accesToken: 'e56b0bc3fc75434689f721fda38c994d9393ef95',
  url: 'https://api-ssl.bitly.com/v4',
};

const cookies = {
  domain: 'ltdev.tipmexico.com' /* 'localhost' */,
};


const dataDog = {
  applicationId: '',
  clientToken: '',
  site: '',
  service: '',
  env: '',
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate: 0,
  sessionReplaySampleRate: 0,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
}

export const environment = {
  production: false,
  templateSuffix: '.v2',
  theme: 'default-theme',
  baseUrl: 'https://ltdev.tipmexico.com',
  strappiUrl: 'https://cmsltdev.tipmexico.com',
  catalog: 'https://ltdev.tipmexico.com/v1/service/catalogs',
  catalogsUrl: 'https://ltdev.tipmexico.com/v1/service/public',
  catalogsUrlV2: 'https://ltdev.tipmexico.com/v1/service/public',
  catalogsUrlV3: 'https://ltdev.tipmexico.com/v1/service/public',
  cotizadorUrl: 'https://ltdev.tipmexico.com/v1/service/public/cotizador',
  cotizadorUrlV2: 'https://ltdev.tipmexico.com/v1/service/public/cotizador',
  cotizadorUrlV3: 'https://ltdev.tipmexico.com/v1/service/public/cotizador',
  keycloak,
  passEncode: 'RAZVCXDIwMjI$',
  buroUrl: 'https://ltdev.tipmexico.com/v1/service/buro',
  riskUrl: `https://ltdev.tipmexico.com/v1/service/riesgo`,
  sse,
  documentManagmentUrl: 'https://ltdev.tipmexico.com/v1/service/documentmanagment',
  documentManagmentUrlPublic: 'https://ltdev.tipmexico.com/v1/service/public/documentmanagment',
  documentManagmentUrlPublicv3: 'https://ltdev.tipmexico.com/v1/service/public/documentmanagment',
  documentAdapterUrl: "https://ltdev.tipmexico.com/v1/service/documentadapter",
  otp: 'https://ltdev.tipmexico.com/v1/service/otp/otp',
  solicitudUrl: `https://ltdev.tipmexico.com/v1/service/solicitud`,
  solicitudValidityUrl:
    'https://ltdev.tipmexico.com/v1/service/clientes/expiration-step',
  creditUrl: 'https://ltdev.tipmexico.com/v1/service/credit',
  creditUrlV2: 'https://ltdev.tipmexico.com/v1/service/credit',
  creditUrlV3: 'https://ltdev.tipmexico.com/v1/service/credit',
  clientesUrl: 'https://ltdev.tipmexico.com/v1/service/clientes',
  clientesUrlV3: 'https://ltdev.tipmexico.com/v1/service/credit',
  clientesPublicUrl: 'https://ltdev.tipmexico.com/v1/service/public/clientes',
  clientesPublicUrlV3: 'https://ltdev.tipmexico.com/v1/service/public/clientes',
  carManagerUrl: 'https://ltdev.tipmexico.com/v1/service/management/car',
  carManagerUrlV2: 'https://ltdev.tipmexico.com/v1/service/management/car',
  paymentUrl: 'https://ltdev.tipmexico.com/v1/service/payment',
  loggerStrategy,
  gtm,
  miFiel,
  bitly,
  cookies,
  dataDog,
  incode
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
